import { render, staticRenderFns } from "./StatisticTabsLite.vue?vue&type=template&id=10bb93a3&scoped=true&"
import script from "./StatisticTabsLite.vue?vue&type=script&lang=js&"
export * from "./StatisticTabsLite.vue?vue&type=script&lang=js&"
import style0 from "./StatisticTabsLite.vue?vue&type=style&index=0&id=10bb93a3&prod&scoped=true&lang=css&"
import style1 from "./StatisticTabsLite.vue?vue&type=style&index=1&id=10bb93a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb93a3",
  null
  
)

export default component.exports